import deepCopy from "./deepCopy";

function createArrayFromSize(size, initialValue) {
  return initialValue
    ? Array.from({ length: size }, _ => deepCopy(initialValue))
    : Array.from({ length: size }, (_, i) => i + 1);
}

export default createArrayFromSize;
